// extracted by mini-css-extract-plugin
export default {"container":"authLayout_container__hlhFA","card":"authLayout_card__zGrkj","logo":"authLayout_logo__bq2Jx"};